module.exports = __webpack_public_path__ + "img/chargingDetailDone.56f5c8f8.svg";